import { InfoCard } from "@components/InfoCard";
import React from "react";

export const AddressesSummary = ({ title }: { title: string }): React.JSX.Element => {
  return (
    <div className="relative bg-white w-full pt-20">
      {/* Header Title */}
      <h2 className="text-4xl font-bold mb-4">{title}</h2>
      <div className="justify-between flex md:gap-x-10 gap-y-10 flex-col md:flex-row lg:flex-row">
        <div className="w-full" data-aos="fade-up-right">
          <InfoCard
            image="./images/church-icon.png"
            bgImage="./images/frauenkirche.png"
            headerText={"Dresden"}
            pa={"St. George Koptische Orthodoxe Kirche"}
            pb={"Hechtstraße 78,"}
            pc={"01127, Dresden"}
            pd={""}
            url={"https://maps.app.goo.gl/hMH5PjTqYGvNVthK8"}
          />
        </div>

        <div className="w-full" data-aos="fade-up-left">
          <InfoCard
            image="./images/church-icon.png"
            bgImage="./images/leipzigcastle.png"
            headerText={"Leipzig"}
            pa={"St. Laurentius Kirche"}
            pb={"Stötteritzer Str. 47,"}
            pc={"04317, Leipzig"}
            pd={""}
            url={"https://maps.app.goo.gl/fLg2gTSSMXWNK6dq8"}
          />
        </div>
      </div>
    </div>
  );
};
